<template>
<div>
    <p class="page-text" v-for="(contenido,index) in contenidos" :key="index" :class="columnasContenido(contenido.TamanoDeLaColumna)">{{contenido.TextoDelContenido}} </p>
</div>          
</template>

<script>
export default {
    props:{
        contenidos:Array
    },
    methods:{
        columnasContenido(columnas){
            var respuesta = 'col-lg-'+columnas
            return respuesta;
        }
    },
  }
</script>

<style scoped>
.page-text{
    padding-top: 2vh;
    font-family: 'Myriad';
    font-size: 1.6em;
}
</style>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/Texto.vue